import DefaultLogo from "../../assets/images/logo.png";
import { cn } from "../../lib/utils";

interface AppLogoProps {
  image?: string;
  className?: string;
  style?: React.CSSProperties;
}

const AppLogo: React.FC<AppLogoProps> = ({ image, className, style }) => {
  return (
    <img
      src={image ?? DefaultLogo}
      style={style}
      className={cn("w-[178px] h-[56px] object-cover", className)}
      alt="Fleet Pro Logo"
    />
  );
};

export default AppLogo;
